<script setup lang="ts">
import type { PaymentMethodResponse } from '@@/types/api';

defineProps<{
  modelValue: boolean;
  isSubmitting: boolean;
  paymentMethods: PaymentMethodResponse[];
  isLoadingMethods: boolean;
}>();

const emit = defineEmits<{
  'update:modelValue': [value: boolean];
  submit: [paymentMethodId: string];
  'card-added': [];
}>();

function close() {
  emit('update:modelValue', false);
}
</script>

<template>
  <v-dialog
    :model-value="modelValue"
    max-width="520"
    :persistent="isSubmitting"
    @update:model-value="emit('update:modelValue', $event)"
  >
    <v-card>
      <v-card-title class="text-h6">Update payment method</v-card-title>
      <v-card-text>
        <StripePaymentMethodSelector
          :payment-methods="paymentMethods"
          :is-loading-methods="isLoadingMethods"
          submit-label="Update payment method"
          :disabled="isSubmitting"
          @submit="emit('submit', $event)"
          @card-added="emit('card-added')"
        />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn variant="text" :disabled="isSubmitting" @click="close">
          Cancel
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
